// extracted by mini-css-extract-plugin
export default {"wrapper":"SC-z","viewport":"TC-z","container":"UC-z","slide":"VC-z"};